import script from "./SubmissionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmissionModal.vue?vue&type=script&setup=true&lang=js"

import "./SubmissionModal.vue?vue&type=style&index=0&id=e6fc997c&scoped=true&lang=scss"

import exportComponent from "/home/nodeapps/vitamins/aaa/frontendBuild/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6fc997c"]])

export default __exports__